export const ACCESS_TOKEN_KEY = "access_token";

// Exchange the App Bridge session token for a Postscript JWT and return the account state.
// Uses fetch (not the axios client) so a 401 here can't recurse through the interceptor.
// The stored token is only touched on a definitive answer (2xx or 404); transient failures
// leave an existing session alone.
export const createSession = async () => {
  const idToken = await window.shopify.idToken();
  const response = await fetch(
    `${process.env.REACT_APP_POSTSCRIPT_API_URL}/v2/sales-channel/session`,
    { method: "POST", headers: { Authorization: `Bearer ${idToken}` } }
  );
  const data = await response.json().catch(() => ({}));

  if (data.access_token) {
    localStorage.setItem(ACCESS_TOKEN_KEY, data.access_token);
  } else if (response.ok || response.status === 404) {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
  }

  return { status: response.status, ok: response.ok, ...data };
};
